 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		157: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~@ak-switcher-chunk-confluence-switcher~@ak-switcher-chunk-generic-switcher~@ak-switcher-chun~f5acf153","1":"vendors~@atlaskit-internal_@atlassian/product-search-dialog/feedback-flag~@atlaskit-internal_@atlass~8436c40d","2":"vendors~@ak-switcher-chunk-confluence-switcher~@ak-switcher-chunk-generic-switcher~@ak-switcher-chun~771b3431","3":"vendors~@atlaskit-internal_@atlassian/product-search-dialog/feedback-flag~@atlaskit-internal_@atlass~9bebdedb","4":"@atlaskit-internal_feedback-collector/i18n-tranlations20","5":"vendors~@atlaskit-internal_@atlassian/product-search-dialog/feedback-flag~@atlaskit-internal_product~67fd6943","6":"vendors~@atlaskit-internal_product-search-dialog/i18n-tranlations22","7":"@atlaskit-internal_@atlassian/product-search-dialog/feedback-flag","8":"@atlaskit-internal_feedback-collector/i18n-tranlations0","9":"@atlaskit-internal_feedback-collector/i18n-tranlations10","10":"@atlaskit-internal_feedback-collector/i18n-tranlations12","11":"@atlaskit-internal_feedback-collector/i18n-tranlations14","12":"@atlaskit-internal_feedback-collector/i18n-tranlations16","13":"@atlaskit-internal_feedback-collector/i18n-tranlations18","14":"@atlaskit-internal_feedback-collector/i18n-tranlations2","15":"@atlaskit-internal_feedback-collector/i18n-tranlations23","16":"@atlaskit-internal_feedback-collector/i18n-tranlations25","17":"@atlaskit-internal_feedback-collector/i18n-tranlations27","18":"@atlaskit-internal_feedback-collector/i18n-tranlations29","19":"@atlaskit-internal_feedback-collector/i18n-tranlations31","20":"@atlaskit-internal_feedback-collector/i18n-tranlations33","21":"@atlaskit-internal_feedback-collector/i18n-tranlations35","22":"@atlaskit-internal_feedback-collector/i18n-tranlations37","23":"@atlaskit-internal_feedback-collector/i18n-tranlations39","24":"@atlaskit-internal_feedback-collector/i18n-tranlations4","25":"@atlaskit-internal_feedback-collector/i18n-tranlations41","26":"@atlaskit-internal_feedback-collector/i18n-tranlations43","27":"@atlaskit-internal_feedback-collector/i18n-tranlations45","28":"@atlaskit-internal_feedback-collector/i18n-tranlations47","29":"@atlaskit-internal_feedback-collector/i18n-tranlations49","30":"@atlaskit-internal_feedback-collector/i18n-tranlations51","31":"@atlaskit-internal_feedback-collector/i18n-tranlations6","32":"@atlaskit-internal_feedback-collector/i18n-tranlations8","33":"@atlaskit-internal_product-search-dialog/async-chunk/prequery-image","34":"@atlaskit-internal_product-search-dialog/i18n-tranlations0","35":"@atlaskit-internal_product-search-dialog/i18n-tranlations10","36":"@atlaskit-internal_product-search-dialog/i18n-tranlations12","37":"@atlaskit-internal_product-search-dialog/i18n-tranlations14","38":"@atlaskit-internal_product-search-dialog/i18n-tranlations16","39":"@atlaskit-internal_product-search-dialog/i18n-tranlations18","40":"@atlaskit-internal_product-search-dialog/i18n-tranlations2","41":"@atlaskit-internal_product-search-dialog/i18n-tranlations20","42":"@atlaskit-internal_product-search-dialog/i18n-tranlations25","43":"@atlaskit-internal_product-search-dialog/i18n-tranlations27","44":"@atlaskit-internal_product-search-dialog/i18n-tranlations29","45":"@atlaskit-internal_product-search-dialog/i18n-tranlations31","46":"@atlaskit-internal_product-search-dialog/i18n-tranlations33","47":"@atlaskit-internal_product-search-dialog/i18n-tranlations35","48":"@atlaskit-internal_product-search-dialog/i18n-tranlations37","49":"@atlaskit-internal_product-search-dialog/i18n-tranlations39","50":"@atlaskit-internal_product-search-dialog/i18n-tranlations4","51":"@atlaskit-internal_product-search-dialog/i18n-tranlations41","52":"@atlaskit-internal_product-search-dialog/i18n-tranlations43","53":"@atlaskit-internal_product-search-dialog/i18n-tranlations45","54":"@atlaskit-internal_product-search-dialog/i18n-tranlations47","55":"@atlaskit-internal_product-search-dialog/i18n-tranlations49","56":"@atlaskit-internal_product-search-dialog/i18n-tranlations51","57":"@atlaskit-internal_product-search-dialog/i18n-tranlations53","58":"@atlaskit-internal_product-search-dialog/i18n-tranlations55","59":"@atlaskit-internal_product-search-dialog/i18n-tranlations57","60":"@atlaskit-internal_product-search-dialog/i18n-tranlations59","61":"@atlaskit-internal_product-search-dialog/i18n-tranlations61","62":"@atlaskit-internal_product-search-dialog/i18n-tranlations63","63":"@atlaskit-internal_product-search-dialog/i18n-tranlations8","64":"vendors~@atlaskit-internal_@atlassian/product-search-dialog/async-chunk/confluence-dialog~@atlaskit-~8c2edd62","65":"vendors~@atlaskit-internal_@atlassian/product-search-dialog/feedback-flag","66":"@ak-switcher-chunk-confluence-switcher","67":"@ak-switcher-chunk-generic-switcher","68":"@ak-switcher-chunk-jira-switcher","69":"@ak-switcher-chunk-trello-switcher","70":"@atlaskit-internal_@atlaskit/tooltip","71":"@atlaskit-internal_@atlassian/search-dialog/show-more/select","72":"@atlaskit-internal_@atlassian/user-picker/custom-option","73":"@atlaskit-internal_@atlassian/user-picker/email-option","74":"@atlaskit-internal_@atlassian/user-picker/group-option","75":"@atlaskit-internal_@atlassian/user-picker/team-option","76":"@atlaskit-internal_async-atlassian-switcher-en-GB","77":"@atlaskit-internal_async-atlassian-switcher-i18n-cs","78":"@atlaskit-internal_async-atlassian-switcher-i18n-da","79":"@atlaskit-internal_async-atlassian-switcher-i18n-de","80":"@atlaskit-internal_async-atlassian-switcher-i18n-en","81":"@atlaskit-internal_async-atlassian-switcher-i18n-en-ZZ","82":"@atlaskit-internal_async-atlassian-switcher-i18n-es","83":"@atlaskit-internal_async-atlassian-switcher-i18n-et","84":"@atlaskit-internal_async-atlassian-switcher-i18n-fi","85":"@atlaskit-internal_async-atlassian-switcher-i18n-fr","86":"@atlaskit-internal_async-atlassian-switcher-i18n-hu","87":"@atlaskit-internal_async-atlassian-switcher-i18n-it","88":"@atlaskit-internal_async-atlassian-switcher-i18n-ja","89":"@atlaskit-internal_async-atlassian-switcher-i18n-ko","90":"@atlaskit-internal_async-atlassian-switcher-i18n-nb","91":"@atlaskit-internal_async-atlassian-switcher-i18n-nl","92":"@atlaskit-internal_async-atlassian-switcher-i18n-pl","93":"@atlaskit-internal_async-atlassian-switcher-i18n-pt-BR","94":"@atlaskit-internal_async-atlassian-switcher-i18n-ru","95":"@atlaskit-internal_async-atlassian-switcher-i18n-sk","96":"@atlaskit-internal_async-atlassian-switcher-i18n-sv","97":"@atlaskit-internal_async-atlassian-switcher-i18n-th","98":"@atlaskit-internal_async-atlassian-switcher-i18n-tr","99":"@atlaskit-internal_async-atlassian-switcher-i18n-uk","100":"@atlaskit-internal_async-atlassian-switcher-i18n-vi","101":"@atlaskit-internal_async-atlassian-switcher-i18n-zh-TW","102":"@atlaskit-internal_async-atlassian-switcher-i18n-zh-ZH","103":"@atlaskit-internal_async-atlassian-switcher-is","104":"@atlaskit-internal_async-atlassian-switcher-pt-PT","105":"@atlaskit-internal_async-atlassian-switcher-ro","106":"@atlaskit-internal_product-search-dialog/async-chunk/search-error-image","107":"@atlaskit-internal_user-picker-i18n-cs","108":"@atlaskit-internal_user-picker-i18n-da","109":"@atlaskit-internal_user-picker-i18n-de","110":"@atlaskit-internal_user-picker-i18n-en","111":"@atlaskit-internal_user-picker-i18n-en_GB","112":"@atlaskit-internal_user-picker-i18n-en_ZZ","113":"@atlaskit-internal_user-picker-i18n-es","114":"@atlaskit-internal_user-picker-i18n-et","115":"@atlaskit-internal_user-picker-i18n-fi","116":"@atlaskit-internal_user-picker-i18n-fr","117":"@atlaskit-internal_user-picker-i18n-hu","118":"@atlaskit-internal_user-picker-i18n-is","119":"@atlaskit-internal_user-picker-i18n-it","120":"@atlaskit-internal_user-picker-i18n-ja","121":"@atlaskit-internal_user-picker-i18n-ko","122":"@atlaskit-internal_user-picker-i18n-nb","123":"@atlaskit-internal_user-picker-i18n-nl","124":"@atlaskit-internal_user-picker-i18n-pl","125":"@atlaskit-internal_user-picker-i18n-pt_BR","126":"@atlaskit-internal_user-picker-i18n-pt_PT","127":"@atlaskit-internal_user-picker-i18n-ro","128":"@atlaskit-internal_user-picker-i18n-ru","129":"@atlaskit-internal_user-picker-i18n-sk","130":"@atlaskit-internal_user-picker-i18n-sv","131":"@atlaskit-internal_user-picker-i18n-th","132":"@atlaskit-internal_user-picker-i18n-tr","133":"@atlaskit-internal_user-picker-i18n-uk","134":"@atlaskit-internal_user-picker-i18n-vi","135":"@atlaskit-internal_user-picker-i18n-zh","136":"@atlaskit-internal_user-picker-i18n-zh_TW","137":"i18n_cs","138":"i18n_da","139":"i18n_de","140":"i18n_es","141":"i18n_et","142":"i18n_fi","143":"i18n_fr","144":"i18n_hu","145":"i18n_it","146":"i18n_ja","147":"i18n_ko","148":"i18n_nb","149":"i18n_nl","150":"i18n_pl","151":"i18n_pt","152":"i18n_ptbr","153":"i18n_ru","154":"i18n_sk","155":"i18n_sv","156":"i18n_zh","158":"nav-quick-search-deferred","159":"vendors~@ak-switcher-chunk-atlassian-switcher","160":"vendors~@ak-switcher-chunk-robot-error-img","161":"vendors~@atlaskit-internal_@atlassian/product-search-dialog/async-chunk/confluence-dialog","162":"vendors~@atlaskit-internal_@atlassian/product-search-dialog/async-chunk/jira-dialog","163":"vendors~@atlaskit-internal_@atlassian/product-search-dialog/smart-user-filter/smart-user-picker","164":"vendors~@atlaskit-internal_@atlassian/search-dialog/filter-group/select","165":"vendors~@atlaskit-internal_@atlassian/search-dialog/search-footer/dropdown-links","166":"vendors~@atlaskit-internal_@atlassian/user-picker/external-user-option","167":"vendors~@atlaskit-internal_product-search-dialog/async-chunk/feedback-collector","168":"vendors~@atlaskit-internal_product-search-dialog/recent-work-client","169":"vendors~atlassiansox-cross-flow-support-deferred","170":"vendors~heartbeat-deferred","171":"vendors~nav-quick-search-deferred"}[chunkId]||chunkId) + "." + "d04e24a5bf1a4197b245" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "__CDN_URL__/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 971);
 	})();

 	webpackJsonpCallback([[], {}, 0, [169]]);
 	return startupResult;
